module.exports = __webpack_public_path__ + "static/media/profile.bea3b4b8.svg";